import React from 'react';

import Alert from '@amzn/meridian/alert';
import Link from '@amzn/meridian/link';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useAppSelector } from 'src/store/store';
import { isUsingT2Experience } from 'src/utils/jmrUtils';

const T2PlusBanner = () => {
  const { backgroundFormData } = useAppSelector((state) => state.newJmrPage);
  const { featureFlags } = useAppSelector((state) => state.user);

  return isUsingT2Experience(featureFlags, backgroundFormData.jobLevel) ? (
    <Row spacingInset={'none none 500 none'} width={'fill'}>
      <Alert type="theme" aria-label="T2+ Alert" width={'100%'}>
        <Text>
          Questions on Return to Work's T2+ experience? Please visit our Wiki&nbsp;
          <Link href="https://w.amazon.com/bin/view/Whs/gmh/health-solutions/rtw/faq/">FAQ</Link>
          &nbsp;page.
        </Text>
      </Alert>
    </Row>
  ) : (
    <></>
  );
};

export default T2PlusBanner;
